import mvtCommentSuggest from '@/common/components/mvtcommentsuggest/mvt-commentsuggest.vue';
import { mapGetters } from 'vuex';
export default {
    name: 'dppSuggestion',
    components: {
        mvtCommentSuggest,
    },
    inject: ['$eventBus'],
    data() {
        return {
            draft: '',
        };
    },
    computed: {
        ...mapGetters('dpp', ['dpp']),
    },
    methods: {
        onSubmit() {
            const message = String(this.draft || '').trim();
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadType: 'ListingAgentQuestionResponsiveDPP',
                    propertyId: this.dpp.propertyId,
                    hideProfile: true,
                    propertyData: this.dpp,
                    hotleadTitle: 'Where should we send your answer to?',
                    showComment: false,
                    ojoFormConfigs: {
                        showCtaLinks: false,
                        showOJOagentInfo: false,
                        showDisclaimer: true,
                        commnetLabel: 'Comments',
                    },
                    buttonText: 'Submit',
                    hideIncentive: true,
                    comment: message || '',
                },
            });
        },
    },
};
